import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=1f5bd38e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=1f5bd38e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5bd38e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f5bd38e')) {
      api.createRecord('1f5bd38e', component.options)
    } else {
      api.reload('1f5bd38e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=1f5bd38e&scoped=true&", function () {
      api.rerender('1f5bd38e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wCgR3LYWV0Q6/JS/comp/DocBox.vue"
export default component.exports